import { format } from 'date-fns';
import { useContext, useState } from 'react';
import {
  IonButton, IonList, IonItem, IonNote, IonLabel, IonItemDivider, IonAccordion, IonAccordionGroup, IonFab
} from '@ionic/react';

import { titleize } from 'lib/text';
import { loadName } from 'helpers/loads';
import { getValue, preventDefault } from 'helpers/events';
import { ProjectContext } from 'components/layouts/Project';
import LogsForm from './logs/LogsForm';
import LogsDownloadButton from './logs/LogsDownloadButton';

const updatedNote = (log) => {
  if (log?.completionTime) return `Completed ${format(log.completionTime, 'Pp')}`;
  if (log?.startTime) return `Started ${format(log.startTime, 'Pp')}`;
  if (log?.updatedAt) return `Updated ${format(log.updatedAt, 'Pp')}`;
};

export default () => {
  const project = useContext(ProjectContext);
  const {data: {loads, logs}} = project;
  const [editHeader, setEditHeader] = useState(!logs);
  const [openLoad, setOpenLoad] = useState(loads.length === 1 ? loads[0].id : null);

  if (editHeader) return <LogsForm done={() => setEditHeader(false)}/>;

  return <>
    <IonList lines="full" className="narrow-container">
      <IonItemDivider>
        Installation Details
        <IonButton slot="end" onClick={preventDefault(() => setEditHeader(true))}>
          Edit
        </IonButton>
      </IonItemDivider>
      <IonItem>
        <IonLabel>Installer</IonLabel>
        {logs.installerName}
      </IonItem>
      <IonItem>
        <IonLabel>Inspector</IonLabel>
        <div className="ion-text-right">
          {logs.inspectorName}<br/>
          {logs.inspectorCompany}
        </div>
      </IonItem>
      {logs.torqueMonitoringDevice && (
        <IonItem>
          <IonLabel>Torque Monitoring Device</IonLabel>
          {logs.torqueMonitoringDevice}
        </IonItem>
      )}
      {logs.installationEquipment && (
        <IonItem>
          <IonLabel>Installation Equipment</IonLabel>
          {logs.installationEquipment}
        </IonItem>
      )}

      <IonItemDivider>
        Pile Logs
      </IonItemDivider>
      <IonAccordionGroup value={openLoad} onIonChange={getValue(setOpenLoad)}>
        {_.map(loads, (load, index) => (
          <IonAccordion key={load.id}
            value={load.id}
            toggleIconSlot="start"
            className={`load-group load-${index}`}
          >
            <IonItem slot="header">
              <IonLabel>{loadName(load, index)}</IonLabel>
              <IonNote>{load.pileCount} {titleize(load.pileType)}</IonNote>
            </IonItem>
            <div slot="content">
              {_.times(load.pileCount, (n) => {
                const pileNumber = n + 1;
                const log = _.get(logs, ['loads', load.id, 'piles', pileNumber]);
                const pilePath = `/projects/${project.id}/logs/${load.id}/${pileNumber}`;
                return (
                  <IonItem key={pileNumber} href={pilePath}>
                    <IonLabel>{log?.pileNo ? log?.pileNo : `#${pileNumber}`}</IonLabel>
                    <IonNote>{updatedNote(log)}</IonNote>
                  </IonItem>
                );
              })}
            </div>
          </IonAccordion>
        ))}
      </IonAccordionGroup>
    </IonList>
    <IonFab slot="fixed" vertical="bottom" horizontal="end">
      <LogsDownloadButton/>
    </IonFab>
  </>;
}
